document.addEventListener('DOMContentLoaded', function () {

    const quizzes = document.querySelectorAll('.section-quiz');

    quizzes.forEach(quiz => {

        const dropdownButton = quiz.querySelector('.quiz-btn-dropdown .quiz-drop-item.active');
        const dropdownMenu = quiz.querySelector('.quiz-dropdown');
        const dropdownItems = quiz.querySelectorAll('.quiz-dropdown .quiz-drop-item');

        if (dropdownButton && dropdownMenu) {
            dropdownButton.addEventListener('click', () => {
                dropdownMenu.classList.toggle('active');

                const activeDataDrop = dropdownButton.dataset.drop;

                dropdownItems.forEach(item => {
                    item.classList.toggle('hidden', item.dataset.drop === activeDataDrop);
                });
            });
        }

        dropdownItems.forEach(item => {
            item.addEventListener('click', () => {
                dropdownItems.forEach(i => i.classList.remove('hidden'));

                dropdownMenu.insertBefore(item, dropdownMenu.firstChild);

                const dropdownName = dropdownMenu.dataset.dropdown;

                dropdownButton.textContent = item.textContent;
                dropdownButton.dataset.drop = item.dataset.drop;

                const inputName = `quiz_field__${dropdownName}`;
                let inputElement = quiz.querySelector(`input[name="${inputName}"]`);

                if (!inputElement) {
                    inputElement = document.createElement('input');
                    inputElement.type = 'hidden';
                    inputElement.name = inputName;
                    dropdownMenu.appendChild(inputElement);
                }

                inputElement.value = item.dataset.value;

                dropdownMenu.classList.remove('active');
            });
        });

        document.addEventListener('click', e => {
            if (
                dropdownButton &&
                dropdownMenu &&
                !dropdownButton.contains(e.target) &&
                !dropdownMenu.contains(e.target)
            ) {
                dropdownMenu.classList.remove('active');
            }
        });

        let currentPage = 1;

        const quizPages = quiz.querySelectorAll('.quiz-page');
        const quizCounts = quiz.querySelectorAll('.quiz-count');
        const nextButtons = quiz.querySelectorAll('.quiz-btn-next');
        const prevButtons = quiz.querySelectorAll('.quiz-btn-prev');
        const lastButton = quiz.querySelector('.quiz-btn');

        const totalPages = quizPages.length;

        function getFieldWrapper(input) {
            return input.closest(
                '.section-quiz-one__question--one-field, ' +
                '.section-quiz-one__question--one-box, ' +
                '.section-quiz-one__question--two-field, ' +
                '.section-quiz-two__page--one-card, ' +
                '.section-quiz-two__page--one-box, ' +
                '.section-quiz-two__page--two-field, ' +
                '.field'
            );
        }

        function clearChoiceError(choices) {
            choices.forEach(input => {
                getFieldWrapper(input)?.classList.remove('quiz-error');
            });
        }

        function validateCurrentPage() {
            const activePage = quiz.querySelector(`.quiz-page[data-page="${currentPage}"]`);

            if (!activePage) {
                return true;
            }

            let valid = true;

            let choiceGroups = [];

            const quizOneQuestions = activePage.querySelectorAll('.section-quiz-one__question');

            if (quizOneQuestions.length) {
                choiceGroups = [...quizOneQuestions];
            } else {
                choiceGroups = [activePage];
            }

            choiceGroups.forEach(group => {
                const choices = group.querySelectorAll('input[type="radio"], input[type="checkbox"]');

                if (!choices.length) {
                    return;
                }

                const checked = [...choices].some(input => input.checked);

                choices.forEach(input => {
                    getFieldWrapper(input)?.classList.toggle('quiz-error', !checked);
                });

                if (!checked) {
                    valid = false;
                }

                choices.forEach(input => {
                    input.addEventListener('change', () => {
                        choices.forEach(i => {
                            getFieldWrapper(i)?.classList.remove('quiz-error');
                        });
                    }, { once: true });
                });
            });

            const requiredFields = activePage.querySelectorAll(
                'input[required]:not([type="radio"]):not([type="checkbox"]), textarea[required]'
            );

            requiredFields.forEach(field => {
                const empty = field.value.trim() === '';

                field.classList.toggle('quiz-error', empty);
                getFieldWrapper(field)?.classList.toggle('quiz-error', empty);

                if (empty) {
                    valid = false;

                    field.addEventListener('input', () => {
                        field.classList.remove('quiz-error');
                        getFieldWrapper(field)?.classList.remove('quiz-error');
                    }, { once: true });
                }
            });

            return valid;
        }

        function updateActiveState(pageNumber) {
            quizPages.forEach(page => page.classList.remove('active'));
            quizCounts.forEach(count => count.classList.remove('active'));

            const activePage = quiz.querySelector(`.quiz-page[data-page="${pageNumber}"]`);
            const activeCount = quiz.querySelector(`.quiz-count[data-page="${pageNumber}"]`);

            if (activePage) {
                activePage.classList.add('active');
            }

            if (activeCount) {
                activeCount.classList.add('active');
            }

            prevButtons.forEach(btn => {
                btn.style.display = pageNumber === 1 ? 'none' : 'flex';
            });

            nextButtons.forEach(btn => {
                btn.style.display = pageNumber === totalPages ? 'none' : 'flex';
            });

            if (lastButton) {
                lastButton.style.display = pageNumber === totalPages ? 'flex' : 'none';
            }
        }

        nextButtons.forEach(btn => {
            btn.addEventListener('click', event => {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();

                if (!validateCurrentPage()) {
                    return false;
                }

                if (currentPage < totalPages) {
                    currentPage++;
                    updateActiveState(currentPage);
                }
            }, true);
        });

        prevButtons.forEach(btn => {
            btn.addEventListener('click', event => {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();

                if (currentPage > 1) {
                    currentPage--;
                    updateActiveState(currentPage);
                }
            }, true);
        });

        quizCounts.forEach(count => {
            count.addEventListener('click', event => {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();

                const selected = parseInt(count.dataset.page, 10);

                currentPage = selected;
                updateActiveState(currentPage);
            }, true);
        });

        updateActiveState(currentPage);

        const radioGroups = quiz.querySelectorAll('.section-quiz-two__page--one-list');

        radioGroups.forEach(group => {
            group.querySelectorAll('input[type="radio"]').forEach(radio => {
                radio.addEventListener('change', () => {
                    group.querySelectorAll('.quiz-radio').forEach(label => {
                        label.classList.remove('active');
                    });

                    if (radio.checked) {
                        radio.closest('.quiz-radio')?.classList.add('active');
                    }
                });
            });
        });

    });

});